<template>

  <form>

    <div class="row">

      <AppFormInput 
        v-for="parameter in formParameter" 
        v-bind:key="parameter.key" 
        v-bind:ref="'jt-form-element-' + parameter.key"
        v-bind:formIsAdd="formIsAdd"
        v-bind:permission="permission"
        v-bind:formCanEdit="formCanEdit"
        v-bind:formInputParameter="parameter"
        v-bind:formData="formData"
        v-on:form-input="onFormInputted"
        v-on:form-change="onFormChanged" >

        <slot v-if="parameter.key" v-bind:name="'jt-form-slot-' + parameter.key" />

      </AppFormInput>
        
    </div>

    <TemplateFeedback ref="formFeedback" />

  </form>

</template>

<script>
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppFormInput from "@/components/App/AppFormInput";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

export default {
  name: "AppForm",
  props: ['formParameter', 'permission'],
  components: {
    AppFormInput,
    TemplateFeedback
  },
  data () {
    return {
      formIsAdd: true,
      formCanEdit: true,
      formData: {},
    }
  },
  created() {
    this.processSelectMultipleFormData();
  },
  mounted() {
  },
  methods: {
    setForm(formIsAdd, formData, formCanEdit) {
      this.$refs['formFeedback'].setFeedbackMessage();
      
      // need [0] if refs is dynamic named
      this.formCanEdit = formCanEdit !== undefined ? formCanEdit : true;
      // TODO kw need actual deep copy of data - JSON.parse(JSON.stringify(x))?
      // TODO kw $.extend(true, {}, formData); won't copy variable with undefined value
      if(this.formIsAdd = formIsAdd) {
        this.formCanEdit = this.hasAddPermission() && this.formCanEdit;
        this.formData = formData ? Object.assign({}, formData) : this.getFormDefaultData();
      } else {
        this.formCanEdit = this.hasEditPermission() && this.formCanEdit;
        this.formData = Object.assign({}, formData);
      }
      this.formParameter.forEach(k => {
        this.$refs['jt-form-element-' + k.key][0].setInputReset(null);
        this.$refs['jt-form-element-' + k.key][0].setFormCanEdit(this.formCanEdit);
      });

      this.processSelectMultipleFormData();
    },
    getFormDefaultData() {
      let temp = {};
      this.formParameter.forEach(parameter => {
        // // select input will show already selected first option even actual value is null if use v-bind:value
        // // select input will show empty selection if use v-model and pass in null
        // if(parameter.form_select) {
        //   temp[parameter.key] = parameter.form_select.getSelectOptionValue(parameter.form_select.data[0]);
        // }
        if(parameter.key === null 
          || parameter.key === undefined
          || parameter.form_checkbox_group
          || parameter.form_html
          || parameter.form_section
        ) {
          return;
        }

        if(parameter.form_default !== undefined) {
          temp[parameter.key] = parameter.form_default;
        } else {
          temp[parameter.key] = undefined;
          // return false;

          try {
            if(window.location.href.includes('localhost') || this.$route.query.test || JSON.parse(localStorage.getItem('user')).username === 'kahwei.chuah@july.technology') {
              let index = this.$route.query.test || 0;
              let now = moment()//.second(0);
              const round = 10;
              const remainder = round - (now.minute() % round);
              const dateTime = moment(now)//.add(remainder, "minutes")
              if(parameter.form_phone) {
                temp[parameter.key] = dateTime.unix() + index;
              } else if(parameter.form_email) {
                if(index) {
                  temp[parameter.key] = 'kahwei.chuah+' +  ((temp['name'] || '').replace(/\s+/g, '').toLowerCase() || dateTime.unix()) + '@july.technology';
                } else {
                  temp[parameter.key] = 'kahwei.chuah+' +  dateTime.format('YYYYMMDD_HHmmss') + '@july.technology';
                }
              } else if(parameter.form_checkbox) {
              } else if(parameter.form_datepicker) {
              } else if(parameter.key.endsWith('CityID')) {
                temp[parameter.key] = 173
              } else if(parameter.key === 'terminationGiroBankAccountNo') {
              } else if(parameter.key === 'nationalID') {
                temp[parameter.key] = new moment().unix();
              } else {
                if(parameter.form_input_attr) {
                  if(parameter.form_input_attr.type === 'Number' || parameter.form_input_attr.type === 'Number') {
                    return;
                  }
                }

                if(parameter.text && parameter.text.endsWith(' *')) {
                  temp[parameter.key] = 'KW ' + parameter.text.substring(0, parameter.text.length - 2) + ' ' + (index || dateTime.format('YYYYMMDD_HHmmss'));
                } else {
                  temp[parameter.key] = 'KW ' + (parameter.text || parameter.key) + ' ' + (index || dateTime.format('YYYYMMDD_HHmmss'));
                }
              }

              // if(parameter.key === 'carparkID') {
              //   temp[parameter.key] = 933;
              // } else if(parameter.key === 'licenseID') {
              //   // temp[parameter.key] = 108;
              // }
            }
          } catch(e) {
          }
        }
      });

      try {
        if(JSON.parse(localStorage.getItem('user')).username === 'kahwei.chuah@july.technology') {
          temp['carparkID'] = 989
        }
      } catch(e) {
      }
      return temp;
    },
    
    validateForm() {
      // return;

      for(var inputParameter of this.formParameter) {
        var validationList = [];
        var genericValidation = inputParameter.form_input_validation;
        var customValidation = this.formIsAdd ? inputParameter.form_add_validation : inputParameter.form_edit_validation;
        
        if(!customValidation && !genericValidation) {
          // these parameter doesn't need default validation
          if(!(inputParameter.index ||
            inputParameter.id ||
            inputParameter.form_section ||
            inputParameter.form_div ||
            inputParameter.form_checkbox ||
            inputParameter.form_html ||
            inputParameter.form_invalid)) {
            validationList.push(validation.validateRequire); // default validation
          }
          
          if(inputParameter.form_email) {
            validationList.push(validation.validateEmail);
          } else if(inputParameter.form_phone) {
            validationList.push(validation.validatePhone);
          }
        } else {
          validationList = validationList.concat(genericValidation || []);
          validationList = validationList.concat(customValidation || []);
        }

        for(var validationFunction of validationList) {
          if(typeof validationFunction !== 'function') {
            continue;
          }
          
          var error = validationFunction(this.formData[inputParameter.key], inputParameter, this.formIsAdd);
          if(error) {
            this.$refs['jt-form-element-' + inputParameter.key][0].setInputError(error);
            let fieldName = inputParameter.text || inputParameter.key;
            fieldName = fieldName.endsWith('*') ? fieldName.substring(0, fieldName.length - 2) : fieldName;
            this.$refs['formFeedback'].setFeedbackError(fieldName + ' - ' + error);
            return error;
          }
        }

        this.$refs['formFeedback'].setFeedbackMessage();
        
        this.$refs['jt-form-element-' + inputParameter.key][0].setInputError(null, true);
      }
    },

    onFormChanged(parameter, value) {
      // will trigger via user interaction or changing of underlying value
      this.$emit('form-change', this.formData, parameter, this.$refs['jt-form-element-' + parameter.key][0]);
      if (document.documentMode || /Edge/.test(navigator.userAgent)) {
        this.$emit('form-input', this.formData, parameter, this.$refs['jt-form-element-' + parameter.key][0]);
      }
    },
    onFormInputted(parameter, value) {
      // will trigger via user interaction only
      // won't trigger on IE11 and Edge
      this.$nextTick(() => {
        this.$emit('form-input', this.formData, parameter, this.$refs['jt-form-element-' + parameter.key][0]);
      });
    },

    processSelectMultipleFormData() {
      this.formParameter.forEach(k => {
        if(k.form_chosen_multiple) {
          if(!this.formData[k]) {
            this.formData[k.key] = [];
          }
        }
      });
    },

    hasAddPermission() {
      return helper.hasAddPermission(this.permission);
    },
    hasEditPermission() {
      return helper.hasEditPermission(this.permission);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/App/AppForm.vue